import { render, staticRenderFns } from "./dynamic-links.vue?vue&type=template&id=1ccb9b20"
import script from "./dynamic-links.vue?vue&type=script&lang=js"
export * from "./dynamic-links.vue?vue&type=script&lang=js"
import style0 from "./dynamic-links.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports